var _ellipse, _rect, _line, _rect2, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.425,
    cy: 31.063,
    rx: 7.182,
    ry: 8.052
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.359,
    y: 2.885,
    width: 4.132,
    height: 11.309,
    rx: 2.066,
    ry: 2.066
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.425,
    y1: 14.194,
    x2: 11.425,
    y2: 22.828
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.518,
    y: 2.885,
    width: 4.132,
    height: 11.309,
    rx: 2.066,
    ry: 2.066
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.584,
    y1: 14.194,
    x2: 30.584,
    y2: 22.828
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.465,
    cy: 29.559,
    r: 0.26
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.387,
    cy: 32.898,
    r: 0.26
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.465,
    cy: 32.898,
    r: 0.26
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.426,
    cy: 31.237,
    r: 0.26
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.387,
    cy: 29.559,
    r: 0.26
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.426,
    cy: 27.291,
    r: 0.26
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.426,
    cy: 35.183,
    r: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.669,39.115h-10.438c-.869,0-1.609-.634-1.742-1.493l-.264-1.714c-.168-1.088-.076-2.201.267-3.247l2.741-8.347c.291-.887,1.119-1.486,2.052-1.486h4.33c.933,0,1.761.599,2.052,1.486l2.741,8.347c.344,1.046.435,2.159.267,3.247l-.264,1.714c-.133.859-.872,1.493-1.742,1.493Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.792,
    y1: 30.314,
    x2: 28.243,
    y2: 35.492
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.376,
    y1: 30.314,
    x2: 32.924,
    y2: 35.492
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorKitchen);
export default __webpack_public_path__ + "static/media/indoor-kitchen.de1cc18aba6c46a8300b88133a0423ff.svg";
export { ForwardRef as ReactComponent };